// Kipay Landing Page Mock Data

export const companyInfo = {
  name: "KIPAY",
  tagline: "La Fluidité au Cœur de Votre Quotidien",
  subtitle: "Votre Carte, Tout l'Écosystème EKIP",
  description: "Une seule carte pour tous vos besoins. KIPAY révolutionne vos paiements et récompense votre fidélité à travers l'écosystème EKIP : carburant, habitat, technologie. Payez, cumulez, économisez.",
  logo: "/images/kipay-logo.png",
  logoTransparent: "/images/kipay-logo-transparent.png",
  holdingLogo: "/images/holding-logo.jpg",
  contact: {
    address: "49 Rue K104 Blvd Latrille Cocody, Abidjan, Côte d'Ivoire",
    phone: "+225 27 22 41 25 25",
    businessPhone: "+225 05 06 06 55 06",
    email: "contact@kipay.net",
    businessEmail: "business@kipay.net",
    supportEmail: "support@kipay.net",
    hours: "Lundi - Vendredi : 8h00 - 20h00"
  },
  social: {
    linkedin: "/company/kipay-ci",
    facebook: "@Kipay",
    instagram: "@kipay_ci",
    twitter: "@KipayCi"
  }
};

export const stats = [
  { value: "1", label: "Carte Unique", description: "pour tout l'écosystème" },
  { value: "3", label: "Filiales", description: "Wayne, KIDH, EKIPTECH" },
  { value: "550+", label: "Agences", description: "bancaires partenaires" },
  { value: "24/7", label: "Support", description: "assistance disponible" }
];

export const pillars = [
  {
    id: 1,
    icon: "CreditCard",
    title: "Carte Co-Brandée",
    subtitle: "Votre Passeport vers l'Écosystème EKIP",
    description: "Carte bancaire Visa/Mastercard co-brandée avec banques partenaires. Design premium.",
    features: ["Visa/Mastercard International", "8 banques partenaires", "Paiement sans contact", "Design exclusif"]
  },
  {
    id: 2,
    icon: "Gift",
    title: "Programme Fidélité",
    subtitle: "Chaque Achat Vous Rapproche de Vos Rêves",
    description: "Points multi-enseignes avec niveaux Bronze, Silver, Gold et avantages exclusifs.",
    features: ["Points cumulables partout", "3 niveaux de fidélité", "Cashback immédiat", "Cadeaux exclusifs"]
  },
  {
    id: 3,
    icon: "Smartphone",
    title: "Wallet Digital",
    subtitle: "Tout Votre Écosystème dans Votre Poche",
    description: "Paiement mobile, suivi points en temps réel, offres personnalisées.",
    features: ["Paiement mobile NFC", "Suivi temps réel", "Notifications", "Apple Pay / Google Pay"]
  }
];

export const cards = [
  {
    id: 1,
    tier: "Bronze",
    color: "silver",
    price: "5 000 FCFA/an",
    income: "> 150 000 FCFA/mois",
    discount: "2%",
    points: "1 point / 1 000 FCFA",
    benefits: [
      "-2% sur tous achats Wayne, KIDH, EKIPTECH",
      "Paiement sans contact jusqu'à 25 000 FCFA",
      "Assurance achats (90 jours)",
      "Application mobile KIPAY"
    ],
    limits: {
      withdrawal: "200 000 FCFA/jour",
      payment: "500 000 FCFA/jour"
    }
  },
  {
    id: 2,
    tier: "Silver",
    color: "slate",
    price: "15 000 FCFA/an",
    income: "> 300 000 FCFA/mois",
    discount: "4%",
    points: "1,5 points / 1 000 FCFA",
    popular: true,
    benefits: [
      "-4% sur tous achats EKIP",
      "Facilités de paiement (3-6 mois sans frais)",
      "Assistance voyage 24/7",
      "Accès salons aéroport (2 passages/an)",
      "Priorité SAV EKIP"
    ],
    limits: {
      withdrawal: "500 000 FCFA/jour",
      payment: "2 000 000 FCFA/jour"
    }
  },
  {
    id: 3,
    tier: "Gold",
    color: "amber",
    price: "50 000 FCFA/an",
    income: "> 800 000 FCFA/mois",
    discount: "6%",
    points: "2 points / 1 000 FCFA",
    benefits: [
      "-6% sur tous achats EKIP",
      "Package domotique EKIPTECH offert (3M FCFA)",
      "Conciergerie 24/7",
      "Facilités paiement 12 mois sans frais",
      "Accès illimité salons aéroport",
      "Conseiller dédié"
    ],
    limits: {
      withdrawal: "1 000 000 FCFA/jour",
      payment: "Illimité"
    }
  }
];

export const partners = {
  banks: [
    { name: "Société Générale CI", agencies: "150+" },
    { name: "BSIC - CI", agencies: "20" },
    { name: "Banque Atlantique", agencies: "40+" },
    { name: "Ecobank", agencies: "120+" },
    { name: "NSIA Banque", agencies: "50+" },
    { name: "Bank of Africa", agencies: "60+" },
    { name: "Coris Bank", agencies: "30+" },
    { name: "Bridge Bank", agencies: "25+" }
  ],
  ecosystem: [
    {
      name: "KIP ENERGY",
      logo: "/images/kip-energy-logo.png",
      description: "Énergie et distribution pétrolière",
      icon: "Zap"
    },
    {
      name: "Wayne CI",
      logo: "/images/wayne-ci-logo.png",
      description: "50+ stations-services, carburants, lubrifiants",
      icon: "Fuel"
    },
    {
      name: "KIDH",
      logo: "/images/kidh-logo.png",
      description: "5 sites immobiliers, 179+ hectares",
      icon: "Home"
    },
    {
      name: "EKIPTECH",
      logo: "/images/ekiptech-logo.png",
      description: "Solutions domotiques, IoT, équipements",
      icon: "Cpu"
    }
  ]
};

export const businessSolutions = {
  fleetCard: {
    title: "Carte Flotte KIPAY",
    subtitle: "Pour Entreprises avec Véhicules de Service",
    features: [
      "Cartes individuelles par véhicule/employé",
      "Plafonds personnalisables",
      "Restrictions (uniquement carburant, ou carburant + accessoires)",
      "Géolocalisation des achats",
      "Reporting détaillé mensuel",
      "Facturation centralisée",
      "Crédit 30/60 jours"
    ],
    benefits: [
      "-3 à -5% sur tous achats Wayne (volume)",
      "Gestion simplifiée (fini les notes de frais)",
      "Contrôle total des dépenses",
      "Lutte contre la fraude",
      "Reporting fiscal automatisé"
    ],
    price: "5 000 FCFA/carte/an (à partir de 10 cartes)"
  },
  employeeBenefits: {
    title: "Programme Avantages Employés",
    subtitle: "Fidélisez Vos Talents avec KIPAY",
    description: "Offrez à vos employés des cartes KIPAY avec un crédit mensuel pré-chargé, utilisable dans tout l'écosystème EKIP.",
    usages: [
      "Carburant pour trajets domicile-travail",
      "Équipements EKIPTECH pour télétravail",
      "Facilités d'accès habitat KIDH"
    ],
    enterpriseBenefits: [
      "Motivation et fidélisation employés",
      "Avantage social moderne et attractif",
      "Déductible fiscalement",
      "Tableau de bord RH",
      "Reporting automatisé"
    ],
    employeeBenefits: [
      "Pouvoir d'achat augmenté",
      "Accès écosystème EKIP",
      "Programme fidélité personnel cumulatif"
    ],
    price: "À partir de 2 000 FCFA/employé/mois"
  },
  giftCard: {
    title: "Carte Cadeaux KIPAY",
    subtitle: "Offrez du Pouvoir d'Achat EKIP",
    occasions: [
      "Cadeaux clients/partenaires",
      "Récompenses employés",
      "Incentives commerciaux",
      "Dotations événements"
    ],
    amounts: "De 10 000 FCFA à 500 000 FCFA",
    validity: "12 mois",
    customizable: "Personnalisable avec votre logo",
    minOrder: "50 cartes"
  }
};

export const loyaltyLevels = [
  {
    level: "Bronze",
    icon: "Award",
    color: "#CD7F32",
    requirement: "Inscription gratuite avec carte KIPAY",
    benefits: [
      "-2% sur tous achats EKIP",
      "1 point / 1 000 FCFA",
      "Offres spéciales mensuelles",
      "Programme de parrainage"
    ]
  },
  {
    level: "Silver",
    icon: "Award",
    color: "#C0C0C0",
    requirement: "Client Wayne régulier (6 mois) OU 10 000 points",
    benefits: [
      "-4% sur tous achats EKIP",
      "1,5 points / 1 000 FCFA",
      "Facilités de paiement (3-6 mois)",
      "Avant-premières produits",
      "Support prioritaire"
    ]
  },
  {
    level: "Gold",
    icon: "Crown",
    color: "#FFD700",
    requirement: "Parrainage 2 acheteurs KIDH OU 50 000 points",
    benefits: [
      "-6% sur tous achats EKIP",
      "2 points / 1 000 FCFA",
      "Package domotique 3M FCFA offert",
      "Conciergerie personnelle",
      "Conseiller EKIP dédié",
      "Événements VIP exclusifs"
    ]
  }
];

export const faqs = [
  {
    question: "Puis-je avoir plusieurs cartes KIPAY ?",
    answer: "Non, une seule carte par personne, mais vous pouvez upgrader votre niveau (Bronze → Silver → Gold)."
  },
  {
    question: "Les points ont-ils une date d'expiration ?",
    answer: "Oui, 12 mois après acquisition. Mais chaque nouvelle transaction réinitialise le compteur."
  },
  {
    question: "Puis-je utiliser ma carte KIPAY hors EKIP ?",
    answer: "Oui, c'est une vraie carte Visa/Mastercard utilisable partout dans le monde. Mais les points et réductions ne s'appliquent que chez EKIP."
  },
  {
    question: "Comment passer de Bronze à Silver/Gold ?",
    answer: "Automatiquement selon vos achats EKIP et parrainages. L'app vous indique votre progression."
  },
  {
    question: "Que se passe-t-il si je perds ma carte ?",
    answer: "Opposition immédiate via l'app (1 clic) ou par téléphone. Carte de remplacement gratuite sous 48h. Vos points sont conservés."
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Choisissez Votre Banque",
    description: "Sélectionnez parmi nos 8 banques partenaires celle où vous avez déjà un compte."
  },
  {
    step: 2,
    title: "Faites Votre Demande",
    description: "En ligne sur kipay.ci, en agence bancaire, en station Wayne, ou en showroom KIDH/EKIPTECH."
  },
  {
    step: 3,
    title: "Recevez Votre Carte",
    description: "Délai 7 jours ouvrés. Livraison gratuite à domicile ou en agence. Activation immédiate via l'app."
  }
];

export const appFeatures = [
  {
    icon: "Wallet",
    title: "Paiement Mobile",
    description: "Payez sans sortir votre carte via QR code ou NFC"
  },
  {
    icon: "TrendingUp",
    title: "Suivi Points",
    description: "Visualisez votre progression en temps réel"
  },
  {
    icon: "Bell",
    title: "Offres Personnalisées",
    description: "Recevez les bonnes offres au bon moment"
  },
  {
    icon: "Shield",
    title: "Sécurité Totale",
    description: "Bloquez votre carte en 1 clic, biométrie"
  }
];
